// IndexedDB-backed offline scan queue using idb-keyval (single key holds an array)
import { get, set } from "idb-keyval";

const KEY = "cd_scan_queue";
const MAX_ATTEMPTS = 3;

export const getQueuedScans = async () => {
  const arr = await get(KEY);
  return Array.isArray(arr) ? arr : [];
};

export const enqueueScan = async (item) => {
  const arr = await getQueuedScans();
  const entry = {
    ...item,
    queued_id: `q_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`,
    queued_at: new Date().toISOString(),
    attempts: 0,
  };
  await set(KEY, [...arr, entry]);
  return entry;
};

export const removeQueuedScan = async (queuedId) => {
  const arr = await getQueuedScans();
  await set(KEY, arr.filter((q) => q.queued_id !== queuedId));
};

// Increment attempt count; if >= MAX_ATTEMPTS, drop the item
export const recordFailedAttempt = async (queuedId) => {
  const arr = await getQueuedScans();
  const next = arr
    .map((q) =>
      q.queued_id === queuedId ? { ...q, attempts: (q.attempts || 0) + 1 } : q
    )
    .filter((q) => (q.attempts || 0) < MAX_ATTEMPTS);
  await set(KEY, next);
  // Return whether the item was dropped
  const stillThere = next.some((q) => q.queued_id === queuedId);
  return { dropped: !stillThere };
};

export const clearQueue = async () => {
  await set(KEY, []);
};
